var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerImgWithNoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 100,
    viewBox: "0 0 130 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.208,
    x2: 0.5,
    y2: 1.134,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed0677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034ea2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176975",
    "data-name": "Group 176975",
    transform: "translate(12137 10442)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145101",
    "data-name": "Rectangle 145101",
    width: 130,
    height: 100,
    transform: "translate(-12137 -10442)",
    opacity: 0,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176974",
    "data-name": "Group 176974",
    transform: "translate(-12137 -10442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29997",
    "data-name": "Path 29997",
    d: "M-18.348,0V-8.46h3.384a3.122,3.122,0,0,1,2.022.582,1.981,1.981,0,0,1,.714,1.626,1.957,1.957,0,0,1-.36,1.188,2.056,2.056,0,0,1-1,.72,2.1,2.1,0,0,1,1.146.708,2.024,2.024,0,0,1,.414,1.308A2.106,2.106,0,0,1-12.756-.6,3.173,3.173,0,0,1-14.82,0Zm.96-4.68h2.28q1.908,0,1.908-1.488t-1.908-1.5h-2.28Zm0,3.888h2.472Q-13-.792-13-2.34t-1.92-1.548h-2.472Zm8.856.9A2.394,2.394,0,0,1-9.606-.126a1.9,1.9,0,0,1-.75-.642,1.591,1.591,0,0,1-.276-.912,1.464,1.464,0,0,1,.33-1.008A1.972,1.972,0,0,1-9.21-3.222a10.493,10.493,0,0,1,2.082-.162h.384v-.372A1.552,1.552,0,0,0-7.05-4.83a1.278,1.278,0,0,0-.978-.33,3.478,3.478,0,0,0-1.02.15,4,4,0,0,0-1.008.486l-.336-.708a3.7,3.7,0,0,1,1.11-.516A4.449,4.449,0,0,1-8.028-5.94a2.264,2.264,0,0,1,1.674.552,2.357,2.357,0,0,1,.546,1.716V0H-6.72V-1.008a1.811,1.811,0,0,1-.7.816A2.031,2.031,0,0,1-8.532.108Zm.156-.732a1.522,1.522,0,0,0,1.176-.5,1.8,1.8,0,0,0,.456-1.266v-.36h-.372a10.121,10.121,0,0,0-1.53.09,1.424,1.424,0,0,0-.78.312.819.819,0,0,0-.222.606,1.039,1.039,0,0,0,.342.8A1.327,1.327,0,0,0-8.376-.624ZM-4.008,0V-5.832h.948v1a1.9,1.9,0,0,1,.816-.828A2.525,2.525,0,0,1-1.056-5.94q2.076,0,2.076,2.3V0H.048V-3.576A1.837,1.837,0,0,0-.27-4.77a1.254,1.254,0,0,0-1.014-.378,1.681,1.681,0,0,0-1.278.5,1.844,1.844,0,0,0-.474,1.326V0ZM2.808,0V-5.832h.948v1a1.9,1.9,0,0,1,.816-.828A2.525,2.525,0,0,1,5.76-5.94q2.076,0,2.076,2.3V0H6.864V-3.576A1.837,1.837,0,0,0,6.546-4.77a1.254,1.254,0,0,0-1.014-.378,1.681,1.681,0,0,0-1.278.5A1.844,1.844,0,0,0,3.78-3.324V0Zm9.444.108A2.939,2.939,0,0,1,10.068-.7a2.988,2.988,0,0,1-.8-2.2,3.388,3.388,0,0,1,.36-1.59,2.636,2.636,0,0,1,.99-1.068,2.779,2.779,0,0,1,1.458-.378,2.351,2.351,0,0,1,1.86.762A3.056,3.056,0,0,1,14.6-3.084v.372H10.212a2.2,2.2,0,0,0,.576,1.518,1.992,1.992,0,0,0,1.464.522A3.131,3.131,0,0,0,13.26-.834a2.741,2.741,0,0,0,.912-.534l.336.684A2.754,2.754,0,0,1,13.5-.1,3.82,3.82,0,0,1,12.252.108ZM12.1-5.22a1.7,1.7,0,0,0-1.308.516,2.257,2.257,0,0,0-.564,1.356h3.54a2.184,2.184,0,0,0-.462-1.38A1.509,1.509,0,0,0,12.1-5.22ZM16.008,0V-5.832h.948v1.044a2.064,2.064,0,0,1,1.92-1.164l.348-.036.072.84-.612.072a1.908,1.908,0,0,0-1.26.522,1.7,1.7,0,0,0-.432,1.23V0Z",
    transform: "translate(65 63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sub-volume",
    transform: "translate(53 17.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11379",
    "data-name": "Path 11379",
    d: "M25.408,19.028l-4.936-3.1,4.936-3.1a1.079,1.079,0,0,0,0-1.75L14.332,4.119a.745.745,0,0,0-.808,0L2.448,11.076a1.079,1.079,0,0,0,0,1.75l4.936,3.1-4.936,3.1a1.079,1.079,0,0,0,0,1.75l11.076,6.958a.746.746,0,0,0,.808,0l11.076-6.958a1.079,1.079,0,0,0,0-1.75ZM13.928,6.123l9.279,5.829L13.928,17.78,4.649,11.952Zm0,19.609L4.649,19.9l4.532-2.847,4.343,2.728a.746.746,0,0,0,.808,0l4.343-2.728L23.207,19.9Z",
    transform: "translate(-2 -4)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImgWithNoBg);
export default __webpack_public_path__ + "static/media/BannerImgWithNoBg.4e9b9bc066bde351927a6de154bee409.svg";
export { ForwardRef as ReactComponent };